import React from 'react';
import { Container, Typography, Box, Paper, Divider, List } from '@mui/material';

const TermsAndConditions = () => {
  const sections = [
    {
      title: "1. Eligibility",
      content: "You must be legally competent to enter into a contract under Indian law. If you're under 18 or otherwise ineligible, you should only use this site under the supervision of a parent or legal guardian."
    },
    {
      title: "2. Registration",
      content: "You may shop as a guest or register on the site. If you register, you must provide accurate, current, and complete information about yourself as prompted by the registration form. You are responsible for maintaining the confidentiality of your account and password."
    },
    {
      title: "3. Communication",
      content: "When you visit the website or send emails to us, you are communicating with us electronically. You consent to receive communications from us electronically. We will communicate with you by email or by posting notices on this site."
    },
    {
      title: "4. User Submissions",
      content: "Anything that you submit to the site and/or provide to us, including but not limited to, questions, reviews, comments, and suggestions will become our sole and exclusive property and shall not be returned to you."
    },
    {
      title: "5. Content Ownership",
      content: "All content included on this site, such as text, graphics, logos, button icons, images, audio clips, digital downloads, and data compilations is the property of Thathva Industries or its content suppliers and protected by international copyright laws."
    },
    {
      title: "6. Product Information",
      content: "We attempt to be as accurate as possible. However, Thathva Industries does not warrant that product descriptions or other content of this site is accurate, complete, reliable, current, or error-free. If a product offered by us is not as described, your sole remedy is to return it in unused condition."
    },
    {
      title: "7. Pricing",
      content: "Except where noted otherwise, the List Price displayed for products on our website represents the full retail price listed on the product itself. Prices are subject to change without notice."
    },
    {
      title: "8. Governing Law",
      content: "These terms and conditions are governed by and construed in accordance with the laws of India and you irrevocably submit to the exclusive jurisdiction of the courts in Hyderabad, Telangana."
    }
  ];

  return (
    <Box sx={{ bgcolor: '#f8f9fa', py: 8 }}>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: { xs: 3, md: 6 }, borderRadius: 4 }}>
          <Typography variant="h3" component="h1" align="center" gutterBottom fontWeight="bold" color="primary">
            Terms & Conditions
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 4 }}>
            Last Updated: March 2026
          </Typography>
          
          <Divider sx={{ mb: 4 }} />
          
          <Box sx={{ mb: 6 }}>
            <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem' }}>
              Welcome to the Thathva Uniforms portal. These Terms & Conditions govern your use of our website and services. By accessing or using our platform, you agree to be bound by these terms.
            </Typography>
          </Box>

          <List sx={{ width: '100%' }}>
            {sections.map((section, index) => (
              <Box key={index} sx={{ mb: 5 }}>
                <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ display: 'flex', alignItems: 'center' }}>
                  {section.title}
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7, pl: 0.5 }}>
                  {section.content}
                </Typography>
              </Box>
            ))}
          </List>

          <Box sx={{ mt: 6, p: 3, bgcolor: 'primary.light', borderRadius: 2, color: 'primary.contrastText' }}>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Questions?
            </Typography>
            <Typography variant="body1">
              If you have any questions regarding these Terms & Conditions, please contact us at support@thathvauniforms.com
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsAndConditions;
